import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { motion, useCycle } from 'framer-motion';
import * as style from './style.module.scss';
import ListenSV from '../../images/listen-sv.svg';
import ListenEN from '../../images/listen-en.svg';
import PlayerButton from '../PlayerButton';

interface PlayerProps {
  song: {
    title: string;
    image: any;
    imageAlt: string;
    url: string;
  };
}

const Player = ({ song }: PlayerProps) => {
  const [isPlayerActive, togglePlayerActive] = useCycle(false, true);

  const card = {
    active: {
      rotateY: '180deg',
    },
    inactive: {
      rotateY: '0deg',
    },
  };

  return (
    <div className={style.player}>
      <motion.div
        className={style.player__card}
        animate={isPlayerActive ? 'active' : 'inactive'}
        variants={card}
      >
        <div className={style.player__cardFront}>
          <GatsbyImage
            image={getImage(song.image)}
            title={song.title}
            alt={song.imageAlt}
          />
        </div>
        <div className={style.player__cardBack}>
          <iframe
            title={song.title}
            src={song.url}
            width="350"
            height="350"
            allow="encrypted-media"
          ></iframe>
        </div>
      </motion.div>
      <PlayerButton
        isPlayerActive={isPlayerActive}
        togglePlayerActive={togglePlayerActive}
      />
      <figure className={style.player__listen}>
        {process.env.GATSBY_SITE_LANG === 'en' ? (
          <ListenEN />
        ) : (
          <ListenSV />
        )}
      </figure>
    </div>
  );
};

export default Player;
